export default __webpack_public_path__ + "static/media/ic-verification.8a9960a1.svg";